import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
export function ModernCommerce() {
  return <main className="flex-grow bg-[#F2F4F0]" data-id="element-245">
      {/* 1. HERO SECTION */}
      <section className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-246">
        <h1 className="text-5xl md:text-6xl font-serif font-semibold text-text mb-6" data-id="element-247">
          Modern Commerce
        </h1>
        <p className="text-xl md:text-2xl text-muted font-sans max-w-3xl mx-auto" data-id="element-248">
          Full-service eCommerce agency for brands who want to move fast.
        </p>
      </section>

      {/* 2. WHAT WE DO SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-249">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
          <div className="max-w-3xl mb-16" data-id="element-251">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-6" data-id="element-252">
              What We Do
            </h2>
            <p className="text-lg text-muted leading-relaxed" data-id="element-253">
              We design and build eCommerce websites using modern tools that let
              us move quickly with more design iterations—so you get better
              results, faster.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-254">
            {['Website Design & Development', 'Platform Migrations', 'Subscription & Retention', 'Point of Sale Setup'].map((item, index) => <div key={index} className="bg-white p-6 rounded shadow-warm border border-border flex items-start" data-id="element-255">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 mr-3 flex-shrink-0" data-id="element-256" />
                <h3 className="text-lg font-semibold text-text" data-id="element-257">{item}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. PLATFORMS SECTION */}
      <section className="py-16 md:py-24 bg-[#F2F4F0]" data-id="element-258">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-12" data-id="element-260">
            Platforms We Work With
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-261">
            {[{
            name: 'Shopify',
            desc: 'Partner Program member, POS agency partner'
          }, {
            name: 'Commerce7',
            desc: 'Wine industry platform'
          }, {
            name: 'WineHub',
            desc: 'Winery eCommerce'
          }, {
            name: 'WinePik',
            desc: 'Agency launch partner'
          }].map((platform, index) => <div key={index} className="space-y-2" data-id="element-262">
                <h3 className="text-xl font-semibold text-text" data-id="element-263">
                  {platform.name}
                </h3>
                <p className="text-muted text-sm" data-id="element-264">{platform.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. INDUSTRIES SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-265">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-267">
            <div data-id="element-268">
              <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-6" data-id="element-269">
                Industries
              </h2>
              <p className="text-lg text-muted leading-relaxed mb-8" data-id="element-270">
                We work across industries but have deep expertise in wine and
                beverage, where we've supported wineries, cellar doors, and DTC
                brands for over a decade.
              </p>

              <div className="flex flex-wrap gap-3" data-id="element-271">
                {['Wine & Beverage', 'Food & Hospitality', 'DTC & Subscription'].map((tag, index) => <span key={index} className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary font-semibold text-sm" data-id="element-272">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. CTA SECTION */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 text-center bg-[#F2F4F0]" data-id="element-273">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-274">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold text-text" data-id="element-275">
            Got a project in mind?
          </h2>

          <p className="text-xl text-muted font-sans" data-id="element-276">
            Let's talk about what you're building.
          </p>

          <div className="pt-4" data-id="element-277">
            <Link to="/contact" data-id="element-278">
              <Button size="lg" data-id="element-279">Get in Touch</Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}